import { INTERESTS } from "@/api/queries/interests";
import { useReactiveVar, useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { interestsVar } from "@/reactiveVars/global";
import { Interest } from "@/__generated__/types";

const PAGE_SIZE = 100;

export const useInterests = (): {
  data: Interest[] | null;
  loading: boolean;
} => {
  const [getInterests] = useLazyQuery(INTERESTS);
  const interestsValue = useReactiveVar(interestsVar);

  useEffect(() => {
    if (interestsValue !== null) return;

    const fetchAllItems = async () => {
      let hasNextPage = true;
      let cursor = null;
      const pages = [];

      while (hasNextPage) {
        const { data } = await getInterests({
          variables: { after: cursor, first: PAGE_SIZE },
        });
        const interestConnection = data?.interests;

        const interests =
          interestConnection?.edges
            ?.map((edge) => edge?.node)
            .filter((m) => !!m) || [];

        pages.push(interests);
        hasNextPage = !!interestConnection?.pageInfo.hasNextPage;
        cursor = interestConnection?.pageInfo.endCursor;
      }

      interestsVar(pages.flat());
    };
    fetchAllItems();
  }, [getInterests, interestsValue]);

  return { data: interestsValue, loading: interestsValue === null };
};
